import { Input } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.js';
import { FilterTableFieldName } from './types.js';

export const NumberRangeInput = ({
  name,
  suffix,
}: {
  name: FilterTableFieldName;
  suffix?: string;
}) => {
  const { control } = useFormContext();
  return (
    <Td type="editable" backgroundColor="white" colSpan={2}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <Input
            id={name}
            size="sm"
            type="number"
            autoFocus
            border="hidden"
            borderRadius={0}
            boxShadow="none!important"
            suffix={suffix}
            prefix="±"
            isInvalid={fieldState.invalid}
            onClear={() => {
              field.onChange('');
            }}
            {...field}
          />
        )}
      />
    </Td>
  );
};
